import { render, staticRenderFns } from "./studentDetails.vue?vue&type=template&id=1c79e127&scoped=true&"
import script from "./studentDetails.vue?vue&type=script&lang=ts&"
export * from "./studentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./studentDetails.vue?vue&type=style&index=0&id=1c79e127&lang=scss&scoped=true&"
import style1 from "./studentDetails.vue?vue&type=style&index=1&id=1c79e127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79e127",
  null
  
)

export default component.exports